var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M507.49 101.721L352.211 256L507.49 410.279C510.297 404.412 512 397.926 512 391V121C512 114.073 510.297 107.588 507.49 101.721Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M467 76H44.9999C38.0729 76 31.5879 77.703 25.7209 80.51L224.184 277.973C241.732 295.521 270.268 295.521 287.816 277.973L486.279 80.51C480.412 77.703 473.927 76 467 76Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51 101.721C1.703 107.588 0 114.073 0 121V391C0 397.927 1.703 404.413 4.51 410.279L159.789 256L4.51 101.721Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M331 277.211L309.027 299.184C279.788 328.423 232.211 328.423 202.972 299.184L181 277.211L25.7209 431.49C31.5879 434.297 38.0729 436 44.9999 436H467C473.927 436 480.412 434.297 486.279 431.49L331 277.211Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b2f90a95.svg";
export { ForwardRef as ReactComponent };